const FACILITATORS = [
    {
        id: "jerrymac",
        name: "Jerry Mac",
        rate: 100,
        email: "jerrymacmail@protonmail.com",
        description: `"In 2008, I became enamoured with The Work of Byron Katie and became determined to learn everything I could about it. Over the next 10 years or so, I attended three schools, five No-Body Intensives, and many other miscellaneous live events with Katie. By 2018, I became certified in The Work and spent over two years volunteering on The Work Helpline and elsewhere."`,
        photo: "./assets/new jerry photo.jpg",
        fontStyle: "italic",
        calendly: ""
    },
    {
        id: "helioschan",
        name: "Helios Chan",
        rate: 80,
        email: "spacewithhelios@gmail.com",
        description: "Helios uses somatic (body) and present moment awareness as key grounding devices to navigate through the process of The Work. Although insights into our true nature are highly valuable, he also believes that the body must have the capacity to hold these insights for any meaningful change to occur. By synthesizing awareness with mind and body, he has had many personal breakthroughs in themes surrounding the story of self, including: childhood trauma, depression, anxiety, and codependency.",
        photo: "./assets/heliosphoto.jpg",
        fontStyle: "none",
        calendly: "https://calendly.com/spacewithhelios-d-r7/30min"
    },
];

function FacilitatorCard({ facilitator }) {
    return (
        <div className="card private-card">
            <img src={facilitator.photo} alt={facilitator.name} className="private-photo" />
            <h3 className="private-name">{facilitator.name}</h3>
            <p className="private-rate">${facilitator.rate}/hour</p>
            <a href={`mailto:${facilitator.email}`} className="private-email">{facilitator.email}</a>
            <p className={`private-description ${facilitator.fontStyle === "italic" ? "is-italic" : ""}`}>
                {facilitator.description}
            </p>
            <a target="_blank" rel="noreferrer" href={facilitator.calendly} className="btn btn--green">Book on Calendly</a>
        </div>
    );
}

export default function Private() {
    return (
        <main className="page page--contained private-page" aria-labelledby="private-heading">
            <header className="page-header page-header--flush private-header">
                <h1 id="private-heading" className="page-title">Private Sessions</h1>
                <p className="page-subtitle private-subtitle">
                    You may book a session with one of us using Calendly. Alternatively, you may contact either one of us by email!
                </p>
            </header>
            <div className="cards-grid private-grid">
                {FACILITATORS.map((f) => (
                    <FacilitatorCard key={f.id} facilitator={f} />
                ))}
            </div>
        </main>

    );
}
